var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { VueType, Component } from '../core';
import './Pager.style.scss';
import { Prop, Watch } from 'vue-property-decorator';
import { DtEid } from '../../../common/reporter';
let Pager = class Pager extends VueType {
    changeVal(isAdd) {
        const val = this.pageIndex + (isAdd ? 1 : -1);
        this.$emit('input', val);
    }
    watchVal() {
        this.emitIndex();
    }
    watchZie() {
        if (this.pageIndex > this.pageNum - 1) {
            this.$emit('input', this.pageNum - 1);
        }
        this.emitIndex();
    }
    created() {
        this.emitIndex();
    }
    emitIndex() {
        const { firstIndex, lastIndex } = this;
        this.$emit('pageChange', {
            firstIndex, lastIndex,
        });
    }
    get hasPrev() {
        return this.pageIndex > 0;
    }
    get hasNext() {
        return this.pageIndex < this.pageNum - 1;
    }
    get pageIndex() {
        return this.value;
    }
    get pageNum() {
        return Math.ceil(this.option.count / this.option.pageSize);
    }
    get firstIndex() {
        return this.pageIndex * this.option.pageSize;
    }
    get lastIndex() {
        const lastListIndex = this.option.count - 1;
        const last = this.firstIndex + this.option.pageSize - 1;
        return last > lastListIndex ? lastListIndex : last;
    }
    render() {
        return <div class="mod_page_small" v-show={this.pageNum != 0}>
            <button class="btn_prev" disabled={!this.hasPrev} title="上一页" dt-eid={DtEid.BUTTON} dt-params="title=left_page&mod_id=subscribe" onClick={() => this.changeVal(false)}>
                <svg class="svg_icon svg_icon_prev" viewBox="0 0 6 10" width="6" height="10">
                    <path d="M1.4 4.7L5 1M1.3 5.3L5 9" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"></path>
                </svg>
            </button>
            <span class="page_num">{this.pageIndex + 1}/{this.pageNum}</span>
            <button class="btn_next" disabled={!this.hasNext} title="下一页" dt-eid={DtEid.BUTTON} dt-params="title=right_page&mod_id=subscribe" onClick={() => this.changeVal(true)}>
                <svg class="svg_icon svg_icon_next" viewBox="0 0 6 10" width="6" height="10">
                    <path d="M4.6 4.7L1 1M4.7 5.3L1 9" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"></path>
                </svg>
            </button>
        </div>;
    }
};
__decorate([
    Prop()
], Pager.prototype, "value", void 0);
__decorate([
    Prop()
], Pager.prototype, "option", void 0);
__decorate([
    Watch('value')
], Pager.prototype, "watchVal", null);
__decorate([
    Watch('option.pageSize')
], Pager.prototype, "watchZie", null);
Pager = __decorate([
    Component
], Pager);
export default Pager;
